var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: [
        _vm.bemBlockMod({
          detail: _vm.type == "detail",
          "detail-primary": _vm.type == "detail" && _vm.subtype == "primary",
          "detail-secondary":
            _vm.type == "detail" && _vm.subtype == "secondary",
          grid: _vm.type == "grid",
          "grid-primary": _vm.type == "grid" && _vm.subtype == "primary",
          "grid-secondary": _vm.type == "grid" && _vm.subtype == "secondary",
          uppercase:
            !_vm.isCustom &&
            (_vm.type == "grid" ||
              (_vm.type == "detail" && _vm.subtype == "primary"))
        }),
        "tag",
        "tag-vue"
      ],
      style: _vm.textColor ? _vm.tagStyles : ""
    },
    [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }